module.exports = __webpack_public_path__ + "static/media/access_control.b5f5549a.jpg";